// extracted by mini-css-extract-plugin
module.exports = {"statistics":"selectedAccountDetail_statistics__19dFH","statCard":"selectedAccountDetail_statCard__14G0o"};